import classNames from 'classnames';
import { ReactNode } from 'react';

import './section-subtitle.scss';

interface SectionSubtitleProps {
    name?: string;
    description?: string;
    showLine?: boolean;
    additionalComponent?: ReactNode;
    emphasis?: boolean;
}

export const SectionSubtitle = ({
    name,
    description,
    showLine,
    additionalComponent,
    emphasis = false,
}: SectionSubtitleProps): JSX.Element => {
    const hidden = !(name || description);
    const hasAdditional = !!additionalComponent;

    return (
        <div className={`section-title ${hasAdditional ? 'additional' : ''}`}>
            <div className="subtitle" hidden={hidden}>
                {name ? <span className="sub-name">{name}:</span> : null}
                {description ? (
                    <span className={classNames('sub-description', { emphasis: emphasis })}>{description}</span>
                ) : null}
                {showLine && !hasAdditional ? <span className="sub-divider"> </span> : null}
            </div>
            {additionalComponent}
        </div>
    );
};

export default SectionSubtitle;
